import clsx from 'clsx';

const variants = {
  primary: 'bg-gradient-hero text-white hover:shadow-lg',
  secondary: 'bg-secondary text-white hover:bg-secondary-dark',
  outline: 'border-2 border-primary text-primary hover:bg-primary/5',
  ghost: 'text-primary hover:bg-primary/5',
  danger: 'bg-error text-white hover:bg-error-dark',
};

const sizes = {
  sm: 'px-3 py-1.5 text-sm min-h-[36px]',
  md: 'px-4 py-2 text-base min-h-[44px]',
  lg: 'px-6 py-3 text-lg min-h-[48px]',
};

export default function Button({
  children,
  variant = 'primary',
  size = 'md',
  disabled = false,
  className = '',
  ...props
}) {
  return (
    <button
      className={clsx(
        'rounded-lg font-semibold transition-all duration-300',
        'focus:outline-none focus:ring-2 focus:ring-cyan-400 focus:ring-offset-2',
        'disabled:opacity-50 disabled:cursor-not-allowed',
        'hover:-translate-y-0.5',
        variants[variant],
        sizes[size],
        className
      )}
      disabled={disabled}
      {...props}
    >
      {children}
    </button>
  );
}
